import React from "react";
import { LucideIcon } from "lucide-react";

type ProfileSectionProps = {
  title: string;
  icon: LucideIcon;
  data: Array<[string, any]>;
  isEmptyValue?: (value: any) => boolean;
};

const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  icon: Icon,
  data,
  isEmptyValue = (value: any) =>
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "object" && Object.keys(value).length === 0),
}) => {
  const validData = data.filter(
    ([, value]) =>
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !isEmptyValue(value)
  );

  if (validData.length === 0) return null; // ✅ hide entire section if empty

  return (
    <section className="bg-white rounded-lg shadow-2xl p-4 sm:p-6">
      <h2 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 flex items-center gap-2">
        <Icon className="text-pink-600" size={18} /> {title}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 sm:gap-y-3 text-xs sm:text-sm">
        {validData.map(([label, value]) => (
          <div
            key={label}
            className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-start gap-x-2 py-1.5 border-b border-gray-100"
          >
            <span className="min-w-0 text-black [overflow-wrap:anywhere]">{label}</span>
            <span aria-hidden="true" className="text-gray-600">:</span>
            <span className="min-w-0 font-medium text-left [overflow-wrap:anywhere]">
              {String(value).trim()}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProfileSection;
